import { Controller } from "stimulus";
import toastr from 'toastr';
import csrfPrefilter from "../components/csrf_prefilter";
import $ from 'jquery';

export default class JobIntentionController extends Controller {
  static targets = ['settingJobModal'];

  submit(event) {
    const optionBtn = event.target;

    csrfPrefilter();
    $.ajax({
      type: "put",
      url: `/work_requirement/change_job_intention`,
      dataType: "json",
      data: { job_change_intention: optionBtn.dataset.params }
    }).then(
      data => {
        this.settingJobModalController.close();
        toastr.success("転職意向の設定を変更しました!");
      },
    )
  }

  launchSettingJobModal() {
    this.settingJobModalController.open();
  }

  get settingJobModalController() {
    return this.application.getControllerForElementAndIdentifier(
      this.settingJobModalTarget,
      "modal"
    );
  }
}
